export default ({ COLORS, FONT_SIZES }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px 0 30px',
    '& h2': {
      color: COLORS.TEXT.MID_GREY.NORMAL,
      ...FONT_SIZES.HEADING_BIG.STYLE,
      margin: '0 0 20px'
    },
    '& a': {
      color: COLORS.BLUE.NORMAL,
      textDecoration: 'none',
      fontWeight: 'bold'
    },
    '& img': {
      width: '131px',
      height: '131px',
      margin: '0 0 10px'
    }
  }
})
